export default __webpack_public_path__ + "static/hodl_vaults_light-53a50546c4875e621a43d0399010ce51.png";